export default __webpack_public_path__ + "static/media/wash.3e329c0e.jpg";